import { AxiosResponse } from 'axios';
import env from '../env';
import { ResponseError } from './dataTypes';
import { sendPost } from './dataUtilities';

export const MAILLIST_BASE_URL = env.maillistBaseUrl;
export const POST_UPDATE_EMAIL_PREFERENCES_ENDPOINT = '/maillists/self/email-preferences';

export const postEmailOptIn = (): Promise<AxiosResponse<any> | ResponseError> => sendPost(
  MAILLIST_BASE_URL + POST_UPDATE_EMAIL_PREFERENCES_ENDPOINT,
  {},
  { optionEmailPreferences: 1 },
);
